import { fetchFromApi } from './api';

export interface ApiUserBrand {
  brandId: string;
  brandName: string;
  allowed: boolean;
}

export interface ProductUserBrands {
  [k: string]: ApiUserBrand[]
}

export type BrandChangeCallback = (brand: ApiUserBrand) => void;

export type BrandChangeStop = () => void;

let brandChangeQueue: Set<BrandChangeCallback> = new Set();

const selectedBrandStorageKey = 'selected-brand';

export const getBrandById = async (productId: string, brandId: string) => {
  const sanitizedBrandId = brandId.toUpperCase();
  const brands = await getBrands(productId);
  const foundBrand = brands.find(b => b.brandId === sanitizedBrandId);

  return foundBrand;
}

export const setSelectedBrand = async (brand: ApiUserBrand): Promise<void> => {
  try {
    sessionStorage.setItem(selectedBrandStorageKey, brand.brandId);
    brandChangeQueue.forEach(cb => cb(brand));
  } catch (error) {
    console.error('Could not save brand or call brand change callback. Aborting', error);
  }
}

export const getOnlyAllowedBrands = async (productId: string) => {
  const brands = await getBrands(productId);
  return brands.filter(a => a.allowed);
}

export const getSelectedBrand = async (productId: string | undefined): Promise<ApiUserBrand | null> => {
  try {
    const brands = await getOnlyAllowedBrands(productId);
    if (!brands.length) {
      return null;
    }

    const selectedBrandId = sessionStorage.getItem(selectedBrandStorageKey);
    const foundBrand = brands.find((el) => el.brandId === selectedBrandId);

    if (foundBrand) {
      return foundBrand;
    }

    return brands[0];
  } catch (error) {
    console.error('Could not get selected brand. Aborting', error);
    return null;
  }
}

let cachedBrands: ProductUserBrands = {};
const fetchBrands = async (productId: string) : Promise<ApiUserBrand[]> => {
  const result = await fetchFromApi(`/api/brands?product=${productId}`);
  cachedBrands[productId] = result;

  return cachedBrands[productId];
}

export const getBrands = async (productId: string) : Promise<ApiUserBrand[]> => {
  if (cachedBrands[productId]) {
    return cachedBrands[productId];
  }

  return fetchBrands(productId);
}


export const onBrandChange = (callback: BrandChangeCallback): BrandChangeStop => {
  brandChangeQueue.add(callback);

  return () => {
    brandChangeQueue.delete(callback);
  }
}
